import { render, staticRenderFns } from "./PageMultisigOrder.vue?vue&type=template&id=3a54ff0f"
import script from "./PageMultisigOrder.vue?vue&type=script&lang=js"
export * from "./PageMultisigOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports